import { InnerBox, TInnerBoxProps } from "@/modules/irohana-components/elements/InnerBox/InnerBox";
import { text } from "@/theme/colors";
import { elevation } from "@/theme/variables";
import { FCC } from "@/types/common";
import { Typography } from "@mui/material";

/** Section card matching the ユーザー設定 design: soft shadow, no border, small (sub16Bold) title. */
export const SettingCard: FCC<TInnerBoxProps> = ({ children, title, ...props }) => (
  <InnerBox
    bordered={false}
    gap="16px"
    sx={{ boxShadow: elevation.lv1 }}
    title={
      title ? (
        <Typography variant="sub16Bold" color={text.primary}>
          {title}
        </Typography>
      ) : undefined
    }
    {...props}
  >
    {children}
  </InnerBox>
);
